import React, { useEffect } from 'react';
import { NumberInput, BooleanInput, useTranslate } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import { shouldFieldBeDisabled } from '../../../utils/eventFormUtils';

/**
 * Event Fees Tab Component
 * Handles fee and commission settings
 */
export const EventFeesTab = ({ systemParams, permissions = {}, isEdit = false }) => {
  const translate = useTranslate();
  const { getValues, setValue } = useFormContext();

  const defaultCommission = systemParams?.variables?.defaultCommissionFee;
  const defaultService = systemParams?.variables?.defaultServiceFee;

  // Create/clone: 0 veya boşsa sistem varsayılanını yaz. Edit'te kayıt değerine dokunma.
  useEffect(() => {
    if (isEdit) return;
    if (defaultCommission == null && defaultService == null) return;
    const currentCommission = getValues('commissionFee');
    const currentService = getValues('servicefee');
    const commissionEmpty =
      currentCommission === undefined ||
      currentCommission === null ||
      currentCommission === '' ||
      Number(currentCommission) === 0;
    const serviceEmpty =
      currentService === undefined ||
      currentService === null ||
      currentService === '' ||
      Number(currentService) === 0;
    if (commissionEmpty && defaultCommission != null && Number(defaultCommission) > 0) {
      setValue('commissionFee', Number(defaultCommission), { shouldDirty: false });
    }
    if (serviceEmpty && defaultService != null && Number(defaultService) > 0) {
      setValue('servicefee', Number(defaultService), { shouldDirty: false });
    }
  }, [isEdit, defaultCommission, defaultService, getValues, setValue]);

  if (!systemParams || !systemParams.variables) {
    return (
      <div style={{ padding: 20, color: 'red' }}>
        <h3>
          {translate(
            'form.system_params_error',
            'System Parameters could not be loaded, this is an error that needs to be reported to Gişe Kıbrıs. Please do so before creating/editing your event.',
          )}
        </h3>
      </div>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: { xs: 'wrap', md: 'nowrap' },
        alignItems: 'flex-start',
        gap: 2,
        '& > *': { flex: { xs: '1 1 100%', md: '1 1 0' }, minWidth: 0 },
      }}
    >
      <NumberInput
        onWheel={(event) => {
          event.target.blur();
        }}
        source="servicefee"
        min={0}
        fullWidth
        label={translate('form.service_fee', 'Event Service Fee (TL)')}
        helperText={translate(
          'form.service_fee_hint',
          'Service fee to cover extra operational cost.',
        )}
        defaultValue={defaultService}
        disabled={shouldFieldBeDisabled('servicefee', permissions)}
      />

      <NumberInput
        onWheel={(event) => {
          event.target.blur();
        }}
        source="commissionFee"
        min={0}
        fullWidth
        label={translate('form.commission_fee', 'Event Commission Fee (%)')}
        helperText={
          defaultCommission != null
            ? translate('form.commission_fee_default_hint', {
                _: `Default from system parameters: %{fee}%`,
                fee: defaultCommission,
              })
            : undefined
        }
        defaultValue={defaultCommission}
        disabled={shouldFieldBeDisabled('commissionFee', permissions)}
      />

      <Box sx={{ pt: 1 }}>
        <BooleanInput
          source="isCommissionExtra"
          defaultValue={false}
          label={translate(
            'form.is_commission_extra',
            'Is commission extra (added to ticket prices)?',
          )}
          helperText={translate(
            'form.is_commission_extra_hint',
            'Please note that the prices for the event will change if this is turned on.',
          )}
        />
      </Box>
    </Box>
  );
};
